import { render, staticRenderFns } from "./BookingPlan.vue?vue&type=template&id=987eb8b6&"
import script from "./BookingPlan.vue?vue&type=script&lang=js&"
export * from "./BookingPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports